import React, { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { MatxLayouts } from './index';
import { MatxSuspense } from 'components';
import history from 'history.js';
import Amplify, { API, Auth } from "aws-amplify";
import useSettings from 'app/hooks/useSettings';
import { AppSelectShopContext } from "app/contexts/AppSelectShopContext";
import { AppControlContext } from 'app/contexts/AppControlContext';
import { DeveloperUuidContext } from "app/contexts/DeveloperUuidContext";
import { AppShopContext } from "app/contexts/AppShopContext";
import { ShopContext } from "app/contexts/ShopContext";
import { navigationsTypeB } from "app/navigations";


const MatxLayout = (props) => {
  const { settings } = useSettings();
  const Layout = MatxLayouts[settings.activeLayout];
  const { isAppControl, setIsAppControl } = useContext(AppControlContext)
  const { shops, setShops } = useContext(ShopContext)

  const { developerId, setDeveloperId } = useContext(AppShopContext)
  const { developerUuId, setDeveloperUuId } = useContext(DeveloperUuidContext)
  const { authority, setAuthority } = useContext(DeveloperUuidContext)

  console.log('ログインしてます=2 : isAppControl', isAppControl);

  const pathname = useLocation().pathname;


  for (var i in navigationsTypeB) {
    var obj = navigationsTypeB[i];
    // 2階層目は飛ばす
    if (pathname == '/storeeditregist') {
      setIsAppControl(true);
      break;
    }
    //console.log(obj);
    if (obj.children) {
      var res = obj.children.find(item => item.path == pathname)
      console.log('res', pathname, res);
      if (res) setIsAppControl(true);
    }
  }



  //console.log('店舗データがある？', shops);
  if (shops?.length == 0) {
    const storedData = localStorage.getItem('ssvShops');

    // JSONデータとしてパース
    const parsedData = JSON.parse(storedData);

    // nameとbrandNameを抽出
    if (parsedData && parsedData?.length > 0) {
      const firstShop = parsedData[0]; // 最初の要素を取得
      const id = firstShop.id;
      const name = firstShop.name;
      const brandId = firstShop.brandId;
      const brandName = firstShop.brandName;
      setShops([{ id: id, name: name, brandId: brandId, brandName: brandName }])
    }
  }
  useEffect(() => {
    console.log('============= setDeveloperUuId ============');
    setDeveloperUuId(localStorage.getItem('ssvDevUUID'))
    setDeveloperId(localStorage.getItem('developerId'))
    setAuthority(localStorage.getItem('ssvAuthority'))
  }, []);
  
  const setAPI = (apiType) => {

    //console.log('MatxLayout setAPI', apiType);

    if (apiType == 2) {

      if (isAppControl || shops?.length == 0) {
        Amplify.configure({
          API: {// Shop API(イートアンド用)
            aws_appsync_graphqlEndpoint: "https://wsuru5bqhfcpxdmozef5dohz2a.appsync-api.ap-northeast-1.amazonaws.com/graphql",
            aws_appsync_region: "ap-northeast-1",
            aws_appsync_authenticationType: "API_KEY",
            aws_appsync_apiKey: "da2-43sflmrgljgrjpnunlwagoscea",
          }
        });
      } else {
        Amplify.configure({
          API: {// SalesView(TEST)
            aws_appsync_graphqlEndpoint: "https://7izfzcfqn5h4hds2kff4gh3fte.appsync-api.ap-northeast-1.amazonaws.com/graphql",
            aws_appsync_region: "ap-northeast-1",
            aws_appsync_authenticationType: "API_KEY",
            aws_appsync_apiKey: "da2-mx4yi43luje2thwz235jsjgw3e",
          }
        });
      }

      var currentAPI = API.configure();
      //console.log('============== MatxLayout shops', isAppControl, shops.length);
      //console.log('============== MatxLayout setAPI', currentAPI);
    } else {

      if (isAppControl || shops?.length == 0) {
        Amplify.configure({
          API: {// Shop API
            aws_appsync_graphqlEndpoint: "https://4vtchgnigzcyni3doeabk4veky.appsync-api.ap-northeast-1.amazonaws.com/graphql",
            aws_appsync_region: "ap-northeast-1",
            aws_appsync_authenticationType: "API_KEY",
            aws_appsync_apiKey: "da2-23ekiri5p5gmdc3jtp7mk4hifa",
          }
        });
      } else {
        Amplify.configure({
          API: {// Shop API
            aws_appsync_graphqlEndpoint: "https://4vtchgnigzcyni3doeabk4veky.appsync-api.ap-northeast-1.amazonaws.com/graphql",
            aws_appsync_region: "ap-northeast-1",
            aws_appsync_authenticationType: "API_KEY",
            aws_appsync_apiKey: "da2-23ekiri5p5gmdc3jtp7mk4hifa",
          }
        });
      }

      var currentAPI = API.configure();
      //console.log('============== MatxLayout shops', isAppControl, shops.length);
      //console.log('============== MatxLayout setAPI', currentAPI);
    }
  }
  //useEffect(() => {
  //  (async () => {

  //    const data = await Auth.currentUserInfo();
  //    console.log('data=' + data)
  //    const userUUID = data.attributes.sub;

  //    console.log('MatxLayout useEffect', data);

  //    if (!data) {
  //      // ログアウトしてる場合はログイン画面に差し戻し
  //      console.log('ログアウトしてる場合はログイン画面に差し戻し');
  //      history.push('/session/signin');
  //    } else {

  //var ssvDevUUID = localStorage.getItem('ssvDevUUID');
  //var devId = localStorage.getItem('developerId');
  //var apiType = localStorage.getItem('API_TYPE');


  setAPI(localStorage.getItem('API_TYPE'))
  //    }
  //  })()
  //}, []);




  return (
    <MatxSuspense>
      <Layout {...props} />
    </MatxSuspense>
  );
};

export default MatxLayout;
